// extracted by mini-css-extract-plugin
export default {"item":"GeneralInfo_item__1WuRV","btn-container":"GeneralInfo_btn-container__GwYu3","links-item":"GeneralInfo_links-item__byq6R","steamID":"GeneralInfo_steamID__FS+Qo"};